import moment from "moment";

export const convertTimeToDate = (value: any) => {
    const initialMoment = moment(value, "HH:mm:ss");
    const initialDate = new Date();
    initialDate.setHours(initialMoment.hours());
    initialDate.setMinutes(initialMoment.minutes());
    return initialDate;
};
